/**
 * PEOPLE PAGE — Combina PersonList (lista) + PersonForm (modale).
 * Pattern analogo a TaskPage: la lista espone onCreateClick e (se il
 * feature flag VITE_ENABLE_EDIT_FORMS e' attivo) onEditClick; entrambi
 * aprono lo stesso modale PersonForm con o senza personId.
 */

import { useState } from 'react';
import PersonList from '../../entities/person/PersonList';
import PersonForm from '../../entities/person/PersonForm';

type DrawerState =
  | { kind: 'closed' }
  | { kind: 'create' }
  | { kind: 'edit'; personId: number };

export function PeoplePage() {
  const [drawer, setDrawer] = useState<DrawerState>({ kind: 'closed' });

  return (
    <>
      <PersonList
        onCreateClick={() => setDrawer({ kind: 'create' })}
        onEditClick={(personId) => setDrawer({ kind: 'edit', personId })}
      />
      {drawer.kind !== 'closed' && (
        <PersonForm
          personId={drawer.kind === 'edit' ? drawer.personId : null}
          onClose={() => setDrawer({ kind: 'closed' })}
        />
      )}
    </>
  );
}
